// /src/components/core/HeadersAndFooters/HeaderContainer.jsx
// Universal header background + clickable logo (no props, no children)
// Layering architecture: sibling to HeaderButtonsXxxx, both position: fixed

import React from 'react';
import useMediaQuery from '../../../hooks/useMediaQuery';

function HeaderContainer() {
  const { isMobile } = useMediaQuery();

  const handleLogoClick = () => {
    console.log('Logo clicked - navigating to locality news feed');

    // Dispatch custom event to switch to locality context
    // This will reset selectedGroup to null and set mode to 'news'
    window.dispatchEvent(new CustomEvent('ournet:context-switch', {
      detail: { context: 'locality' }
    }));
  };

  // Desktop: 80px, Mobile: 50px
  const headerHeight = isMobile ? '50px' : '80px';
  const contentBarHeight = isMobile ? '46px' : '56px';
  const logoHeight = isMobile ? '30px' : '40px';
  // Center logo vertically in white content bar
  const logoTop = isMobile ? '12px' : '12px';

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      height: headerHeight,
      background: '#EDF2F8',
      zIndex: 100
    }}>
      {/* Background bar */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: headerHeight,
        background: '#EDF2F8'
      }} />

      {/* White content bar with shadow */}
      <div style={{
        position: 'absolute',
        top: '4px',
        left: 0,
        right: 0,
        height: contentBarHeight,
        background: 'white',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }} />

      {/* Clickable Logo */}
      <div
        onClick={handleLogoClick}
        style={{
          position: 'absolute',
          top: logoTop,
          left: '20px',
          cursor: 'pointer',
          zIndex: 4,
          transition: 'opacity 0.2s'
        }}
        onMouseOver={(e) => e.currentTarget.style.opacity = '0.8'}
        onMouseOut={(e) => e.currentTarget.style.opacity = '1'}
      >
        <img
          src="/images/logos/header-logo.png"
          alt="OurNet Logo"
          style={{
            height: logoHeight,
            display: 'block'
          }}
          onError={(e) => {
            // Fallback if image not found
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />

        {/* Fallback logo if image doesn't exist */}
        <div style={{
          display: 'none',
          width: logoHeight,
          height: logoHeight,
          background: '#024B99',
          borderRadius: '50%',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: isMobile ? '12px' : '16px',
          fontWeight: 'bold',
          color: 'white'
        }}>
          on
        </div>
      </div>
    </div>
  );
}

export default HeaderContainer;
